import apiBaseState from "~/constants/apiBaseState";
import Vueset from "~/utils/Vueset";

const getState = () => {
    return {
        getActivityFeedState: apiBaseState(),
        createActivityFeedState: apiBaseState(),
        deleteActivityFeedState: apiBaseState(),
        updateActivityFeedState: apiBaseState(),
        loadingMoreActivityFeed: null,
        pusherNotifications: [],
        getActivityFeedCommentState: apiBaseState(),
        createActivityFeedCommentState: apiBaseState(),
        updateActivityFeedCommentState: apiBaseState(),
        deleteActivityFeedCommentState: apiBaseState(),
    };
};

export const state = () => (getState());

export const mutations = {
    RESET_STORE(state) {
        const s = getState();
        Object.keys(s).forEach(key => {
            state[key] = s[key];
        });
    },
    PUSHER_NOTIFICATION(state, payload) {
        const mappedPayload = {
            pushed: true,
            id: payload.model_id,
            allow_comments: payload.allow_comments,
            title: payload.title,
            slug: payload.slug,
            text: payload.text,
            active: payload.active,
            live_at: payload.live_at,
            model_id: payload.model_id,
            model_type: payload.model_type,
            created_at: payload.created_at,
            comments_count: 0,
            media: payload.media,
            comments: [],
            likes: {
                upvote: {
                    count: 0,
                    voted_by_user: false,
                },
                downvote: {
                    count: 0,
                    voted_by_user: false,
                },
            },
            user: null
        };
        state.pusherNotifications.unshift(mappedPayload);
    },
    SET_GET_ACTIVITY_FEED(state, payload) {
        state.getActivityFeedState = payload;
    },
    SET_ACTIVITY_FEED_LOADING_MORE_STATE(state, payload) {
        state.loadingMoreActivityFeed = payload;
    },
    SET_ACTIVITY_FEED_MANUALLY(state, payload) {
        if (!state.getActivityFeedState.data) {
            return;
        }
        state.getActivityFeedState.data.meta = payload.meta;
        state.getActivityFeedState.data.data.push(...payload.data);
        state.loadingMoreActivityFeed = false;
    },
    UNSHIFT_GET_ACTIVITY_FEED(state, payload) {
        state.getActivityFeedState.data.data.unshift(payload);
    },
    SET_CREATE_ACTIVITY_FEED(state, payload) {
        state.createActivityFeedState = payload;
    },
    SET_DELETE_ACTIVITY_FEED_ITEM(state, payload) {
        state.deleteActivityFeedState = payload;
    },
    DELETE_ACTIVITY_FEED_ITEM_BY_SLUG(state, slug) {
        const matchedIndex = state.getActivityFeedState.data.data.findIndex(item => item.slug === slug);
        if (matchedIndex > -1) {
            state.getActivityFeedState.data.data.splice(matchedIndex, 1);
        }
    },
    SET_UPDATE_ACTIVITY_FEED(state, payload) {
        state.updateActivityFeedState = payload;
    },
    UPDATE_ACTIVITY_FEED_ITEM_BY_MATCH(state, payload) {
        const matchedIndex = state.getActivityFeedState.data.data.findIndex(item => item.model_id === payload.model_id && item.model_type === payload.model_type);
        if (matchedIndex > -1) {
            state.getActivityFeedState.data.data.splice(matchedIndex, 1, payload);
        }

        const matchedIndexPusher = state.pusherNotifications.findIndex(item => item.model_id === payload.model_id && item.model_type === payload.model_type);
        if (matchedIndexPusher > -1) {
            state.pusherNotifications.splice(matchedIndexPusher, 1, payload);
        }
    },

    ADD_COMMENT_TO_ACTIVITY_POST(state, { payload, model_id, model_type, type = 'unshift' }) {
        const updateComments = (list) => {
            const matchedIndex = list.findIndex(item => item.model_id === model_id && item.model_type === model_type);
            if (matchedIndex > -1) {
                if (type === 'unshift') {
                    list[matchedIndex].comments_count += 1;
                }
                if (list[matchedIndex].comments) {
                    type === 'unshift'
                        ? list[matchedIndex].comments.unshift(payload.data)
                        : list[matchedIndex].comments.push(payload.data);
                } else {
                    Vueset(list[matchedIndex], 'comments', payload.data);
                }
            }
        };

        updateComments(state.getActivityFeedState.data.data);
        updateComments(state.pusherNotifications);
    },

    UPDATE_COMMENT_FROM_ACTIVITY_POST(state, {model_id, model_type, commentId, payload}) {
        const matchedIndex = state.getActivityFeedState.data.data.findIndex(item => item.model_id === model_id && item.model_type === model_type);
        if (matchedIndex > -1) {
            const commentMatchIndex = state.getActivityFeedState.data.data[matchedIndex].comments.findIndex(comment => comment.model_id === commentId);
            if (commentMatchIndex > -1) {
                if(payload){
                    state.getActivityFeedState.data.data[matchedIndex].comments.splice(commentMatchIndex, 1, payload.data);
                }
                else{
                    state.getActivityFeedState.data.data[matchedIndex].comments.splice(commentMatchIndex, 1);
                    state.getActivityFeedState.data.data[matchedIndex].comments_count -= 1;
                }
            }
        }
        const matchedIndexPusher = state.pusherNotifications.findIndex(item => item.model_id === model_id && item.model_type === model_type);
        if (matchedIndexPusher > -1) {
            const commentMatchIndex = state.pusherNotifications[matchedIndexPusher].comments.findIndex(comment => comment.model_id === commentId);
            if (commentMatchIndex > -1) {
                if(payload){
                    state.pusherNotifications[matchedIndexPusher].comments.splice(commentMatchIndex, 1, payload.data);
                }else{
                    state.pusherNotifications[matchedIndexPusher].comments.splice(commentMatchIndex, 1);
                    state.pusherNotifications[matchedIndexPusher].comments_count -= 1;
                }
            }
        }
    },
    SET_GET_ACTIVITY_FEED_COMMENTS(state, payload) {
        state.getActivityFeedCommentState = payload;
    },
    SET_CREATE_ACTIVITY_FEED_COMMENT(state, payload) {
        state.createActivityFeedCommentState = payload;
    },
    SET_UPDATE_ACTIVITY_FEED_COMMENT(state, payload) {
        state.updateActivityFeedCommentState = payload;
    },
    SET_DELETE_ACTIVITY_FEED_COMMENT(state, payload) {
        state.deleteActivityFeedCommentState = payload;
    },
};

export const actions = {
    INITIALISE_PUSHER_LISTENER({state, commit, rootState}, {projectSlug, echo}) {
        if (!rootState.auth.user) return;
        const channel = `App.ActivityFeed.${projectSlug}.${rootState.auth.user.id}`;
        echo.private(channel).notification((data) => {
            const matchedIndex = state.getActivityFeedState.data.data.findIndex(item => item.model_id === data.model_id && item.model_type === data.model_type);

            const matchedIndexPusher = state.pusherNotifications.findIndex(item => item.model_id === data.model_id && item.model_type === data.model_type);

            if (matchedIndex > -1 || matchedIndexPusher > -1) {
                commit('UPDATE_ACTIVITY_FEED_ITEM_BY_MATCH', {...data});
            } else {
                commit('PUSHER_NOTIFICATION', data);
            }
        });
    },
    async GET_ACTIVITY_FEED({commit, state}, {accountSlug, projectSlug, isParticipant, loadMore, ...params}) {
        const url = isParticipant
            ? `/participant/${projectSlug}/activity-feed`
            : `/accounts/${accountSlug}/${projectSlug}/activity-feed`;
        if (loadMore) {
            commit('SET_ACTIVITY_FEED_LOADING_MORE_STATE', true);
            params.page = (state.getActivityFeedState.data?.meta.current_page + 1) || 1;
        }
        const whyApiResponse = await this.$whyApi.get({
            url,
            params,
            pauseMutations: loadMore,
            mutation: "activityFeed/SET_GET_ACTIVITY_FEED",
            errorMessage: "Error getting posts",
            notify: this.$notify
        });
        if (loadMore) {
            commit('SET_ACTIVITY_FEED_MANUALLY', whyApiResponse.data);
        }
        return whyApiResponse;
    },
    async CREATE_ACTIVITY_FEED({commit, state}, {accountSlug, projectSlug, ...payload}) {
        const url = `/accounts/${accountSlug}/${projectSlug}/activity-feed`;
        const whyApiResponse = await this.$whyApi.post({
            url,
            data: payload,
            handleMedia: true,
            mutation: "activityFeed/SET_CREATE_ACTIVITY_FEED",
            errorMessage: "Error creating post",
            notify: this.$notify
        });
        return whyApiResponse;
    },
    async DELETE_ACTIVITY_FEED_ITEM({commit, state}, {accountSlug, projectSlug, activityFeedItemSlug}) {
        const url = `/accounts/${accountSlug}/${projectSlug}/activity-feed/${activityFeedItemSlug}`;
        const whyApiResponse = await this.$whyApi.delete({
            url,
            mutation: "activityFeed/SET_DELETE_ACTIVITY_FEED_ITEM",
            errorMessage: "Error deleting post",
            notify: this.$notify
        });
        commit('DELETE_ACTIVITY_FEED_ITEM_BY_SLUG', activityFeedItemSlug);
        return whyApiResponse;
    },
    async UPDATE_ACTIVITY_FEED({commit, state}, {accountSlug, projectSlug, activityFeedItemSlug, ...payload}) {
        const url = `/accounts/${accountSlug}/${projectSlug}/activity-feed/${activityFeedItemSlug}`;
        const whyApiResponse = await this.$whyApi.post({
            url,
            data: payload,
            handleMedia: true,
            mutation: "activityFeed/SET_UPDATE_ACTIVITY_FEED",
            errorMessage: "Error updating post",
            notify: this.$notify
        });
        commit('UPDATE_ACTIVITY_FEED_ITEM_BY_MATCH', whyApiResponse.data);
        return whyApiResponse;
    },
    async GET_ACTIVITY_FEED_COMMENTS({rootState, commit}, {accountSlug, projectSlug, postSlug, page}) {
        const baseUrl = rootState.auth.user.isAdmin ? `accounts/${accountSlug}/${projectSlug}` : `/participant/${projectSlug}`;
        const url = `${baseUrl}/activity-feed/${postSlug}/comments`;
        const whyApiResponse = await this.$whyApi.get({
            url,
            params: {
                page,
                length: 3
            },
            mutation: "activityFeed/SET_GET_ACTIVITY_FEED_COMMENTS",
            errorMessage: "Error getting comments",
            notify: this.$notify
        });
        return whyApiResponse;
    },
    async CREATE_ACTIVITY_FEED_COMMENT({rootState, commit}, {accountSlug, projectSlug, postSlug, model_id, model_type, ...payload}) {
        const baseUrl = rootState.auth.user.isAdmin ? `accounts/${accountSlug}/${projectSlug}` : `/participant/${projectSlug}`;
        const url = `${baseUrl}/activity-feed/${postSlug}/comments`;
        const whyApiResponse = await this.$whyApi.post({
            url,
            data: payload,
            mutation: "activityFeed/SET_CREATE_ACTIVITY_FEED_COMMENT",
            errorMessage: "Error creating comment",
            notify: this.$notify
        });

        commit('ADD_COMMENT_TO_ACTIVITY_POST', {
            payload: whyApiResponse,
            model_id,
            model_type
        });

        return whyApiResponse;
    },
    async UPDATE_ACTIVITY_FEED_COMMENT({rootState, commit}, {accountSlug, projectSlug, commentId, postSlug, model_id, model_type, ...payload}) {
        const baseUrl = rootState.auth.user.isAdmin ? `accounts/${accountSlug}/${projectSlug}` : `/participant/${projectSlug}`;
        const url = `${baseUrl}/activity-feed/${postSlug}/comments/${commentId}`;
        const whyApiResponse = await this.$whyApi.put({
            url,
            data: payload,
            mutation: "activityFeed/SET_UPDATE_ACTIVITY_FEED_COMMENT",
            errorMessage: "Error updating comment",
            notify: this.$notify
        });
        commit('UPDATE_COMMENT_FROM_ACTIVITY_POST', {
            model_id,
            model_type,
            commentId,
            payload: whyApiResponse
        });
        return whyApiResponse;
    },
    async DELETE_ACTIVITY_FEED_COMMENT({rootState, commit}, {accountSlug, projectSlug, postSlug, model_id, commentId, model_type}) {
        const baseUrl = rootState.auth.user.isAdmin ? `accounts/${accountSlug}/${projectSlug}` : `/participant/${projectSlug}`;
        const url = `${baseUrl}/activity-feed/${postSlug}/comments/${commentId}`;
        const whyApiResponse = await this.$whyApi.delete({
            url,
            mutation: "activityFeed/SET_DELETE_ACTIVITY_FEED_COMMENT",
            errorMessage: "Error deleting comment",
            notify: this.$notify
        });
        commit('UPDATE_COMMENT_FROM_ACTIVITY_POST', {
            model_id,
            model_type,
            commentId
        });
        return whyApiResponse;
    },
};
